// Question type definitions
export type QuestionType = 'short_answer' | 'paragraph' | 'multiple_choice' | 'multiple_select' | 'date' | 'time';
export type RoleType = 'both' | 'mentor' | 'mentee';
export type MatchingImportance = 'none' | 'low' | 'medium' | 'high' | 'critical';

export enum CampaignMode {
  InPerson = 'inperson',
  Hybrid = 'hybrid',
  Virtual = 'virtual'
}
// Frontend models (camelCase)
export interface ApplicationDetails {
  id?: string;
  campaign_id: string;
  organization_id: string;
  include_availability: boolean;
  include_location: boolean;
  campaign_mode: CampaignMode;
  sections: Section[];
  questions: ApplicationQuestion[];
}

export interface Section {
  id: string;
  title: string;
}

export interface ApplicationQuestion {
  id: string;
  question: string;
  type: QuestionType;
  options?: string[];
  required: boolean;
  section_id: string; // From API: snake_case
  for_role: RoleType;  // From API: snake_case
  matching_importance: MatchingImportance; // From API: snake_case
  matching_question_id?: string; // From API: snake_case
}

export interface ApplicationMetrics {
  estimated_completion_time: number;
  number_checkbox_questions: number;
  number_dropdown_questions: number;
  number_paragraph_questions: number;
  number_multiple_choice_questions: number;
  number_short_answer_questions: number;
  total_questions: number;
}